import { applyMotions } from '@design-system/migration-utils';
import type { FileInfo, API, Transform } from 'jscodeshift';

import { codemodOrder } from './codemod-order.js';

export default function codeshiftMigrationCodemod(
  fileInfo: FileInfo,
  api: API,
): ReturnType<Transform> {
  const j = api.jscodeshift;
  const ast = j(fileInfo.source);

  const hasModifications = applyMotions(j, ast, codemodOrder);

  return hasModifications ? ast.toSource() : null;
}
